<template>
  <div>
    <b-nav-item v-if="route.path" :to="buildPath(route.path)">
      <font-awesome-icon
        v-if="route.meta.sidebar.icon"
        :icon="route.meta.sidebar.icon"
        style="width: 18px"
        class="mr-2"
      />
      <span v-html="route.meta.navbar.displayName" />
    </b-nav-item>
    <div
      v-else
      :class="`d-flex ml-3 mb-2 ${route.click ? 'blue link' : ''}`"
      @click="route.click ? route.click() : null"
    >
      <font-awesome-icon
        v-if="route.meta.sidebar.icon"
        :icon="route.meta.sidebar.icon"
        style="width: 18px"
        class="mr-2 mt-1 blue"
      />
      <div class="wm-100 d-flex">
        <div
          :style="popoverHelp && popoverHelp.style"
          v-html="route.meta.navbar.displayName"
        />
        <div v-if="popoverHelp">
          <font-awesome-icon
            :icon="['fa', 'question-circle']"
            class="ml-2 text-muted"
            :id="popoverHelp.id"
          />

          <b-popover
            :target="popoverHelp.id"
            triggers="hover"
            placement="bottom"
          >
            <template v-slot:title>{{ popoverHelp.title }}</template>
            <div class="popover-content" style="width: 150px">
              {{ popoverHelp.text }}
            </div>
          </b-popover>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Prop, Vue, Component } from 'vue-property-decorator'
import { routeBuild } from '@/utils/urls'

@Component
export default class RouteCard extends Vue {
  @Prop(Object) readonly route!: any
  @Prop(Object) readonly popoverHelp?: any

  private buildPath(url: string) {
    const options = this.route.meta.sidebar?.routeBuildOptions
    return options ? routeBuild(url, options) : url
  }
}
</script>

<style lang="scss" scoped>
@import '@/scss/_colors.scss';
.blue {
  color: map-get($french-palette, 'blue-3');
}
.link:hover {
  cursor: pointer;
}
</style>
